import axios from 'axios';
import user from '../utils/user';

export default {
  async regenerate(proposalKey, contractSavePdf, typeSavePdf) {
    try {
      const response = await axios.post(
        `${process.env.VUE_APP_API_VIDA_URL}/pdf/auto/regenerate`,
        {
          proposalKey,
          contractSavePdf,
          typeSavePdf,
        },
        {
          headers: {
            Authorization: `Bearer ${user.getUserAuthToken()}`,
          },
        },
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};
